/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { Type } from "@sinclair/typebox";
import { RevisionTagSchema, SessionIdSchema } from "../core/index.js";
// Return type is intentionally derived.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const Message = (tChange) => Type.Object({
    revision: RevisionTagSchema,
    originatorId: SessionIdSchema,
    changeset: tChange,
    version: Type.Optional(Type.Number()),
});
//# sourceMappingURL=messageFormat.js.map